export default __webpack_public_path__ + "static/media/Group1463101.95f0a4fa.svg";